import { useTranslation } from "@nova/use-translation"

export const WorkspaceBodyGridSectionHeader = ({ title }: { title: string }) => {
    const { t } = useTranslation()

    return (
        <div className="mb-6">
            <small className="xs text-gray-50 select-none">{t(title)}</small>
        </div>
    )
}
